const configReducer = (state = {}, action) => {
	if(action.type === 'SET_CONFIG') return action.config;
	return state;
}

export default configReducer;